/**
 * School calendar for 2026-2027, Federation Wallonie-Bruxelles.
 *
 * Domain data, deliberately not derived from a library: official Belgian
 * school closures are set by decree each year and cannot be computed. When the
 * year changes, add a sibling file and switch the import in `lib/calendar.ts`.
 */

export interface SchoolClosure {
  /** Inclusive ISO date (YYYY-MM-DD). */
  readonly start: string;
  /** Inclusive ISO date (YYYY-MM-DD). */
  readonly end: string;
  readonly label: string;
}

export const SCHOOL_YEAR_START = '2026-08-24';
export const SCHOOL_YEAR_END = '2027-07-02';
export const SCHOOL_YEAR_LABEL = '2026-2027';

export const SCHOOL_CLOSURES: readonly SchoolClosure[] = [
  { start: '2026-10-19', end: '2026-11-01', label: 'Vacances d’automne' },
  { start: '2026-11-02', end: '2026-11-02', label: 'Fête des morts' },
  { start: '2026-11-11', end: '2026-11-11', label: 'Armistice' },
  { start: '2026-12-21', end: '2027-01-03', label: 'Vacances d’hiver' },
  { start: '2027-02-09', end: '2027-02-09', label: 'Mardi gras' },
  { start: '2027-02-22', end: '2027-03-07', label: 'Vacances de détente' },
  { start: '2027-03-29', end: '2027-03-29', label: 'Lundi de Pâques' },
  { start: '2027-04-26', end: '2027-05-09', label: 'Vacances de printemps' },
  { start: '2027-05-17', end: '2027-05-17', label: 'Lundi de Pentecôte' },
] as const;
